import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { IonButton, IonButtons, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { PredefinedColors } from '@ionic/core';
import { MenuCloseButton } from './MenuCloseButton';
import { MenuBackButton } from './MenuBackButton';
import { IThemeColor } from '../theme/IThemeColor';
import { MinusIcon } from '../theme/Icons';

const useStyles = createUseStyles({
    header: {
        '& ion-title': {
            paddingInlineStart: 16
        }
    }
});

export interface IModalHeaderProps {
    title: string;
    backHandler?: () => void;
    closeHandler: () => void;
    minimizeHandler?: () => void;
    hideCloseButton?: boolean;
    centerTitle?: boolean;
    titleColor?: IThemeColor;
    buttonColor?: PredefinedColors;
}

// The fixed header every modal shares: title, optional back and minimize buttons, close button.
// Stays put while the modal's body scrolls beneath it.
export const ModalHeader: FC<IModalHeaderProps> = ({
    title,
    backHandler,
    closeHandler,
    minimizeHandler,
    hideCloseButton = false,
    centerTitle,
    titleColor,
    buttonColor
}) => {
    const classes = useStyles();

    const titleStyles: React.CSSProperties = {};
    if (centerTitle){
        titleStyles.textAlign = 'center';
        titleStyles.marginLeft = (backHandler ? undefined : 52);
        titleStyles.marginRight = (!hideCloseButton ? undefined : 52);
    }

    return (
        <IonHeader translucent className={classes.header}>
            <IonToolbar color={titleColor}>
                <IonTitle style={titleStyles}>{title}</IonTitle>
                <IonButtons slot="start">
                    {backHandler && (
                        <MenuBackButton onClick={backHandler} color={buttonColor} />
                    )}
                </IonButtons>
                <IonButtons slot="end" style={{ marginRight: 4 }}>
                    {minimizeHandler && (
                        <IonButton
                            onClick={minimizeHandler}
                            color={buttonColor}
                            shape="round"
                            data-id="modal-minimize-button"
                            style={{ '--padding-start': '12px', '--padding-end': '12px', minHeight: 42, marginRight: -4 }}
                        >
                            <span style={{ position: 'relative', top: 3 }}>
                                <MinusIcon color="light" />
                            </span>
                        </IonButton>
                    )}
                    {!hideCloseButton && (
                        <MenuCloseButton onClick={closeHandler} color={buttonColor} />
                    )}
                </IonButtons>
            </IonToolbar>
        </IonHeader>
    );
};
